import React from 'react';
import Layout from '../Layout';
import { Box, Container, Flex, Progress, Text } from '@chakra-ui/react';

const Header = ({ heading }) => {
  return (
    <Text fontSize="34px" color="#1b254b" fontWeight="700">
      {heading ?? 'Test Me Mode'}
    </Text>
  );
};

const Body = ({ constantText, dynamicText }) => {
  const [idx, setIdx] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setIdx(idx => (idx + 1) % dynamicText.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [dynamicText.length]);

  return (
    <Flex direction="column" textAlign="center">
      <Text
        fontSize={{ base: '1.8rem', md: '3rem' }}
        color="#1b254b"
        fontWeight="700"
        mb="1rem"
      >
        {constantText ?? 'Generate Your Quiz'}
      </Text>

      <Progress
        size="lg"
        height={{ base: '20px', md: '32px' }}
        isIndeterminate
        margin={{ base: '0px 10px', lg: '0px 100px' }}
        borderRadius="10px"
      />

      <Text
        fontSize={{ base: '1rem', md: '1.3rem' }}
        color="#718096"
        fontWeight="500"
        mt="0.4rem"
      >
        {dynamicText[idx] ?? 'Compiling your study materials'}
      </Text>
    </Flex>
  );
};

const ProgressPage = ({ headerText, subHeadingText, dynamicText }) => {
  return (
    <Layout
      header={() => <Header heading={headerText} />}
      body={() => (
        <Body constantText={subHeadingText} dynamicText={dynamicText ?? []} />
      )}
    />
  );
};

export default ProgressPage;

export { Body };
